module.exports = __webpack_public_path__ + "static/media/nickles1.2edeca5f.jpg";